<template>
  <div class="category-search">
    <input v-model="query" @input="emitQuery" :placeholder="queryPlaceholder" />

    <button v-if="hasQuery" @click.prevent="clearQuery">
      <Sprite class="clear-query" name="cross" />
    </button>

    <div v-else>
      <Sprite name="search" />
    </div>
  </div>
</template>

<script>
import Sprite from '@/components/Sprite'

export default {
  name: 'CategorySearch',

  data() {
    return {
      query: '',
      queryPlaceholder: 'Filter Categories'
    }
  },

  components: {
    Sprite
  },

  computed: {
    hasQuery() {
      return !!this.query
    }
  },

  props: {
    options: Array
  },

  methods: {
    emitQuery(el) {
      let value = el.target.value
      this.$emit('filter', value)
    },

    clearQuery() {
      this.query = ''
      this.$emit('filter', '')
    },

    getSuggestion() {
      let query = this.$route.query.category
      if (query) {
        this.queryPlaceholder = `Search (e.g. ${query})`
      }
    }
  },

  mounted() {
    this.getSuggestion()
  }
}
</script>

<style lang="sass" scoped>
@import '../../stylesheets/base/variables'
@import '../../stylesheets/base/theme'
@import '../../stylesheets/helpers/mixins'

.category-search
  background: #fff
  box-shadow: 0px 6px 6px -1px rgba(0, 0, 0, 0.1)
  display: flex
  align-items: center
  margin-top: 6px
  position: sticky
  top: 0
  z-index: 2

.sprite
  width: 20px
  height: 20px
  opacity: 0.25
  margin-right: $gap-small

  @include themify($themes)
    fill: themed('color-secondary')

.clear-query
  &:hover
    opacity: 1

input
  padding: $gap-small
  width: 100%
  font-size: 16px
  border: rgba(0, 0, 0, 0.1)
  font-family: $font-body

  &:focus
    outline: none
</style>
